import React from 'react'
import BtnDefault from '../Components/BtnDefault'
import '../Styles/spotify-section.css'


function Spotify() {
  return (
    <div id='spotify-section' className='padding-50 flex-center flex-column flex__gap-50 medium-checkered-background-dark'>
      <iframe  src="https://open.spotify.com/embed/artist/0gkOmPEVRFqAVlu1Z78s5H?utm_source=generator&theme=0" width="80%" height="470" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
      <BtnDefault socialMedia="Spotify" link="https://open.spotify.com/intl-pt/artist/0gkOmPEVRFqAVlu1Z78s5H?si=yOIc7c-TS3mWEFwcQ7PywA" />
    </div>
  )
}

export default Spotify
